/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  OrganizationDto,
  UpdateOrganizationDto,
} from '../models/index';
import {
    OrganizationDtoFromJSON,
    OrganizationDtoToJSON,
    UpdateOrganizationDtoFromJSON,
    UpdateOrganizationDtoToJSON,
} from '../models/index';

export interface UpdateOrganizationRequest {
    id: number;
    updateOrganizationDto: UpdateOrganizationDto;
}

/**
 * 
 */
export class OrganizationServiceApi extends runtime.BaseAPI {

    /**
     * Updates organization by ID
     */
    async updateOrganizationRaw(requestParameters: UpdateOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateOrganization().'
            );
        }

        if (requestParameters['updateOrganizationDto'] == null) {
            throw new runtime.RequiredError(
                'updateOrganizationDto',
                'Required parameter "updateOrganizationDto" was null or undefined when calling updateOrganization().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/organization/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateOrganizationDtoToJSON(requestParameters['updateOrganizationDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationDtoFromJSON(jsonValue));
    }

    /**
     * Updates organization by ID
     */
    async updateOrganization(requestParameters: UpdateOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationDto> {
        const response = await this.updateOrganizationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
